import * as SessionAction from './Session';
import * as ProfileAction from './Profile';
import * as PreferencesAction from './Preferences';

export const Session = SessionAction;
export const Profile = ProfileAction;
export const Preferences = PreferencesAction;